import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { sitecorePublicEndpoints } from "components/utility/api/Api";
import DocumentCenterList from "./DocumentCenterList";

const DocumentCenter = (props) => {
	const [docCenterStatus, setDocCenterStatus] = useState({ isLoading: false, isError: false }); // defaults are 'false'
	const [documentGridData, setDocumentGridData] = useState({
		documentGridData: {
			linkDrawers: [
				{
					title: "",
					subtitle: "",
					links: [
						{
							name: "",
							url: "",
							type: ""
						}
					]
				}
			],
			toggleCollapseText: {
				collapse: "",
				expand: ""
			}
		},
		additionalDocuments: {
			title: "",
			links: []
		},
		generalDocuments: {
			title: "",
			links: []
		}
	});

	useEffect(() => {
		const abortController = new AbortController();
		const api = sitecorePublicEndpoints.documentCenter;

		const fetchData = async () => {
			try {
				setDocCenterStatus({ isLoading: true, isError: false });
				const additionalDocuments = (await window["additionalDocs"])
					? JSON.parse(JSON.stringify(window["additionalDocs"]))
					: null;
				const generalDocuments = (await window["generalDocs"])
					? JSON.parse(JSON.stringify(window["generalDocs"]))
					: null;
				const response = await fetch(api, {
					headers: {
						"Content-Type": "application/json"
					},
					method: "POST",
					body: JSON.stringify({ gridid: `${props.dataset.gridid}` }),
					signal: abortController.signal
				});

				if (response.ok) {
					const json = await response.json();
					setDocumentGridData({
						documentGridData: json,
						additionalDocuments: additionalDocuments,
						generalDocuments: generalDocuments
					});
					setDocCenterStatus({ isLoading: false, isError: false });
				} else {
					setDocCenterStatus({ isLoading: false, isError: true });
				}
			} catch (error) {
				console.error(error);
				setDocCenterStatus({ isLoading: false, isError: true });
			}
		};

		fetchData();

		return () => {
			abortController.abort(); // cleanup fetch
		};
	}, [props.dataset.gridid]);

	const errorMessage = ""; // TODO: hardcode error message or read from CMS

	return (
		<div className="document-center">
			<DocumentCenterList
				data={documentGridData}
				isLoading={docCenterStatus.isLoading}
				isError={docCenterStatus.isError}
				errorMessage={errorMessage}
			/>
		</div>
	);
};

DocumentCenter.propTypes = {
	gridid: PropTypes.string
};

export default DocumentCenter;
